function getEvents(pageId, hoverHeaderId) {
  if (
    process.env.STORYBOOK_DISABLE_ANIMATIONS === "1" ||
    process.env.STORYBOOK_DISABLE_ANIMATIONS
  ) {
    return {};
  }

  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_OUT",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-3",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-5",
          },
        },
        mediaQueries: ["main"],
        target: {
          id: `${pageId}|${hoverHeaderId}`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|${hoverHeaderId}`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1653005128663,
      },
      "e-5": {
        id: "e-5",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_OVER",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e",
          },
        },
        mediaQueries: ["main"],
        target: {
          id: `${pageId}|${hoverHeaderId}`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|${hoverHeaderId}`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1653005128663,
      },
      "e-13": {
        id: "e-13",
        name: "",
        animationType: "custom",
        eventTypeId: "MOUSE_MOVE",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: { appliesTo: "PAGE", styleBlockIds: [], id: `${pageId}` },
        targets: [],
        config: [
          {
            continuousParameterGroupId: "a-p",
            selectedAxis: "X_AXIS",
            basedOn: "VIEWPORT",
            reverse: false,
            smoothing: 50,
            restingState: 50,
          },
          {
            continuousParameterGroupId: "a-p-2",
            selectedAxis: "Y_AXIS",
            basedOn: "VIEWPORT",
            reverse: false,
            smoothing: 50,
            restingState: 50,
          },
        ],
        createdOn: 1699439217790,
      },
    },
    actionLists: {
      "a-3": {
        id: "a-3",
        title: "CTA 38 link [Hover Out]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-3-n",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 0,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".cta38_link-image-wrapper",
                    selectorGuids: ["610e8645-9e6a-4400-619a-aea7234b79e2"],
                  },
                  value: 0,
                  unit: "",
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "a-3-n-2",
                actionTypeId: "GENERAL_DISPLAY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 0,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".cta38_link-image-wrapper",
                    selectorGuids: ["610e8645-9e6a-4400-619a-aea7234b79e2"],
                  },
                  value: "none",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: false,
        createdOn: 1651452062047,
      },
      "a-2": {
        id: "a-2",
        title: "CTA 38 link [Hover On]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-2-n",
                actionTypeId: "GENERAL_DISPLAY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 0,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".cta38_link-image-wrapper",
                    selectorGuids: ["610e8645-9e6a-4400-619a-aea7234b79e2"],
                  },
                  value: "none",
                },
              },
              {
                id: "a-2-n-2",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".cta38_link-image-wrapper",
                    selectorGuids: ["610e8645-9e6a-4400-619a-aea7234b79e2"],
                  },
                  value: 0,
                  unit: "",
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "a-2-n-3",
                actionTypeId: "GENERAL_DISPLAY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 0,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".cta38_link-image-wrapper",
                    selectorGuids: ["610e8645-9e6a-4400-619a-aea7234b79e2"],
                  },
                  value: "flex",
                },
              },
              {
                id: "a-2-n-4",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 0,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".cta38_link-image-wrapper",
                    selectorGuids: ["610e8645-9e6a-4400-619a-aea7234b79e2"],
                  },
                  value: 1,
                  unit: "",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: true,
        createdOn: 1651452062047,
      },
      a: {
        id: "a",
        title: "CTA 38 Image Movement",
        continuousParameterGroups: [
          {
            id: "a-p",
            type: "MOUSE_X",
            parameterLabel: "Mouse X",
            continuousActionGroups: [
              {
                keyframe: 0,
                actionItems: [
                  {
                    id: "a-n",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".cta38_link-image",
                      },
                      xValue: -50,
                      xUnit: "%",
                      yUnit: "PX",
                      zUnit: "PX",
                    },
                  },
                ],
              },
              {
                keyframe: 100,
                actionItems: [
                  {
                    id: "a-n-2",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".cta38_link-image",
                      },
                      xValue: 0,
                      xUnit: "%",
                      yUnit: "PX",
                      zUnit: "PX",
                    },
                  },
                ],
              },
            ],
          },
          {
            id: "a-p-2",
            type: "MOUSE_Y",
            parameterLabel: "Mouse Y",
            continuousActionGroups: [
              {
                keyframe: 0,
                actionItems: [
                  {
                    id: "a-n-3",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".cta38_link-image",
                      },
                      yValue: -50,
                      xUnit: "PX",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                ],
              },
              {
                keyframe: 100,
                actionItems: [
                  {
                    id: "a-n-4",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".cta38_link-image",
                      },
                      yValue: 50,
                      xUnit: "PX",
                      yUnit: "vh",
                      zUnit: "PX",
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
